import { Icon } from "@iconify/react/dist/iconify.js";
import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import styled from "styled-components";
import { fetchGeneralObject } from "../Redux/slices/otherSlice";
import { useDispatch, useSelector } from "react-redux";

const NavRap = styled.div`
  .upper-nav button {
    background: #ffffff;
    width: 58px;
    height: 24px;
    border-style: none;
    border-radius: 5px;
    color: #1b2a50;
    font-size: 14px;
    font-weight: 400;
  }
  .upper-nav p {
    color: #ffffff;
    font-size: 14px;
    font-weight: 400;
  }
  .upper-nav {
    display: flex;
    gap: 15px;
    align-items: center;
    justify-content: center;
    background: #1b2a50;
    width: 100%;
    padding: 20px;
  }
  .search-div {
    position: relative;
    width: 449px;
    height: 40px;
  }
  .search-div input {
    border: 1px solid #1b2a5080;
    border-radius: 7px;
    width: 449px;
    height: 40px;
    padding-left: 20px;
  }
  .search-icon-div {
    height: 36px;
    width: 48px;
    border-top-right-radius: 6px;
    border-bottom-right-radius: 6px;
    background: #f5f5f5;
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: 2px;
    right: 2px;
  }
  .middle-nav-right {
    display: flex;
    align-items: center;
    gap: 30px;
  }
  .sigin-div p {
    color: #1b2a50;
    font-size: 16px;
    font-weight: 400;
  }
  .sigin-div {
    display: flex;
    align-items: center;
    gap: 10px;
  }
  .middle-nav-left button,
  .nav-mobile-down button {
    color: #fffffe;
    font-size: 16px;
    font-weight: 600;
    background: #2d81eb;
    width: 201px;
    height: 40px;
    border-radius: 7px;
    border-style: none;
  }

  .middle-nav-left button:hover {
    background: rgb(95, 147, 211);
  }
  .middle-nav-left {
    display: flex;
    align-items: center;
    gap: 20px;
  }
  .middle-nav,
  .down-nav {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 20px 50px;
    border-bottom: 1px solid #1b2a501a;
  }
  .advance-search p {
    color: #1b2a50;
    font-weight: 400;
    font-size: 16px;
  }
  .advance-search {
    display: flex;
    align-items: center;
    gap: 10px;
    cursor: pointer;
  }
  .link {
    text-decoration: none;
    color: #1b2a50;
    font-size: 16px;
    font-weight: 600;
  }
  .link.active {
    color:rgb(110, 115, 123);

  }
  .navbar,
  .down-nav-right {
    display: flex;
    align-items: center;
    gap: 20px;
  }
  .right-1 p,
  .right-2 p {
    color: #1b2a50;
    font-size: 16px;
    font-weight: 600;
  }
  .right-1,
  .right-2 {
    display: flex;
    align-items: center;
    gap: 5px;
  }

  .nav-mobile,
  .mobile-navbar {
    display: none;
  }

  @media (max-width: 1024px) {
    .nav-mobile {
      display: block;
    }
    .middle-nav-left {
      display: none;
    }
    .navbar {
      display: none;
    }
    .navbar-mobile-top {
      display: flex;
      flex-direction: column;
      gap: 20px;
    }
    .nav-mobile-down {
      display: flex;
      flex-direction: column;
      gap: 15px;
    }
    .mobile-navbar {
      background: #ffffff;
      width: 300px;
      height: 100vh;
      position: fixed;
      top: 150px;
      left: 0px;
      display: flex;
      flex-direction: column;
      gap: 50px;
      padding: 30px;
      z-index: 1000;
    }
    .mobile-navbar.active {
      display: none;
    }
  }
  @media (max-width: 768px) {
    .middle-nav-right {
      flex-wrap: wrap;
    }
    .mobile-navbar {
      top: 200px;
    }
  }
  @media (max-width: 678px) {
    .mobile-navbar {
      top: 230px;
    }
  }
  @media (max-width: 540px) {
    .search-div input,
    .search-div {
      width: 300px;
    }
    .upper-nav {
      flex-wrap: wrap;
      justify-content: flex-start;
    }
    .mobile-navbar {
      top: 260px;
    }
  }
  @media (max-width: 370px) {
    .middle-nav,
    .down-nav {
      padding: 20px;
    }
    .search-div input,
    .search-div {
      width: 250px;
    }
    .mobile-navbar {
      top: 280px;
    }
  }
`;

const Nav = () => {
  const dispatch = useDispatch()

  const [activeLink, setActiveLink] = useState("")
  const navigate = useNavigate();
  const [clicked, setClicked] = useState(false);
  const handleClick = () => {
    setClicked(!clicked);
  };
  const token = localStorage.getItem("userToken");
  const { general,  error } = useSelector((state) => state.others);


  console.log(general);
  
  useEffect(() => {
          dispatch(fetchGeneralObject()); // Call API on component mount
        }, [dispatch]);
  const { pathname } = useLocation();
  useEffect(() => {
    setClicked(false);
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [pathname]);

  const location = useLocation();

  const handleSiginin = () => {
    if (token) {
      navigate("/users/dashboard")
    } else {
      navigate("/signin")

    }
  };
  const handleadvanceSearch = () => {
    navigate("/advanceSearch");
  };
  const handleMovehome = () => {
    navigate("/");
  };

const handleLinkChange = (link) => {
  setActiveLink(link)
}


  return (
    <NavRap>
      <nav>
        <div className="upper-nav">
          <p>
           {general?.data?.websetting?.site_title}
          </p>
        </div>
        <div className="middle-nav">
          <div className="middle-nav-right">
            <div className="nav-mobile" onClick={handleClick}>
              {clicked ? (
                <Icon
                  width="30px"
                  height="30px"
                  icon="prime:times"
                  style={{ color: "black" }}
                />
              ) : (
                <Icon
                  width="30px"
                  height="30px"
                  icon="mdi-light:menu"
                  style={{ color: "black" }}
                />
              )}
            </div>
            <img onClick={handleMovehome} src="/images/logo.png" alt="" />
            {/* <div className="search-div">
              <input type="text" placeholder="Search" />
              <div className="search-icon-div">
                <Icon
                  width="16px"
                  height="16px"
                  icon="material-symbols:search-rounded"
                  style={{ color: "#1B2A50" }}
                />
              </div>
            </div> */}
          </div>
          <div className="middle-nav-left">
          {location.pathname === "/advanceSearch" ? (
                ""
              ): (
            <div onClick={handleadvanceSearch} className="advance-search">
              <Icon
                width="16px"
                height="16px"
                icon="material-symbols:search-rounded"
                style={{ color: "#1B2A50" }}
              />
             
              <p>Advance search</p>
                
            </div>
              )}
            <button onClick={handleSiginin}>{token ? "Dashboard" :"Become a contributor"}</button>
            </div>
        </div>
        <div className="down-nav">
          <div className="navbar">
            
            <Link to="/about"  onClick={() => handleLinkChange("about")}
            className={`link ${activeLink=== "about" ? "active" : ""}`}>
              About Us
            </Link>
            <Link to="/framework"  onClick={() => handleLinkChange("framework")}
            className={`link ${activeLink=== "framework" ? "active" : ""}`}>
            Framework</Link>
           
            <Link to="/result"  onClick={() => handleLinkChange("resource")}
            className={`link ${activeLink=== "resource" ? "active" : ""}`}>
              Resources
            </Link>
            <Link to="/advanceSearch" onClick={() => handleLinkChange("explore")}
            className={`link ${activeLink=== "explore" ? "active" : ""}`}>
              Explore
            </Link>
            <Link to="/contact"  onClick={() => handleLinkChange("contact")}
            className={`link ${activeLink=== "contact" ? "active" : ""}`}>Contact Us
            </Link>
            <Link to="/faq"  onClick={() => handleLinkChange("faq")}
            className={`link ${activeLink=== "faq" ? "active" : ""}`}>FAQs
            </Link>
          </div>


          <div className="down-nav-right">
          <Link to="/donation"  onClick={() => handleLinkChange("donation")}
            className={`link ${activeLink=== "donation" ? "active" : ""}`}>Donation</Link>
            <div className="right-1">
              <Icon
                width="16px"
                height="16px"
                icon="jam:world"
                style={{ color: "#1B2A50" }}
              />
              <p>EN</p>
              <Icon
                width="10px"
                height="10px"
                icon="ep:arrow-down"
                style={{ color: "#1B2A50" }}
              />
            </div>
          
          </div>
        </div>
      </nav>

      <div className={!clicked ? "mobile-navbar active" : "mobile-navbar"}>
        <div className="navbar-mobile-top">
        <Link to="/about"  onClick={() => handleLinkChange("about")}
            className={`link ${activeLink=== "about" ? "active" : ""}`}>
              About Us
            </Link>
            <Link to="/framework"  onClick={() => handleLinkChange("framework")}
            className={`link ${activeLink=== "framework" ? "active" : ""}`}>
            Framework</Link>
           
            <Link to="/result"  onClick={() => handleLinkChange("resource")}
            className={`link ${activeLink=== "resource" ? "active" : ""}`}>
              Resources
            </Link>
            <Link to="/advanceSearch" onClick={() => handleLinkChange("explore")}
            className={`link ${activeLink=== "explore" ? "active" : ""}`}>
              Explore
            </Link>
            <Link to="/contact"  onClick={() => handleLinkChange("contact")}
            className={`link ${activeLink=== "contact" ? "active" : ""}`}>Contact Us</Link>
            <Link to="/faq"  onClick={() => handleLinkChange("faq")}
            className={`link ${activeLink=== "faq" ? "active" : ""}`}>FAQs
            </Link>
        </div>
        <div className="nav-mobile-down">
          <div onClick={handleadvanceSearch} className="advance-search">
            <Icon
              width="16px"
              height="16px"
              icon="material-symbols:search-rounded"
              style={{ color: "#1B2A50" }}
            />
            <p>Advance search</p>
          </div>
          <div className="sigin-div">
            <Icon
              width="16px"
              height="16px"
              icon="octicon:person-16"
              style={{ color: "#1B2A50" }}
            />
           
          </div>
          <button onClick={handleSiginin}>Become a contributor</button>
        </div>
      </div>
    </NavRap>
  );
};

export default Nav;
